import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_legal_overtime_limits_are_not_being_complied_w_select_all'

export const dataPointDefinition = {
  retracedId: 'which_legal_overtime_limits_are_not_being_complied_w_select_all',
  name: 'Which legal overtime limits are not being complied with? ',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'DAILY_LIMITS_ON_OVERTIME_HOURS_WORKED_',
      text: 'Daily limits on overtime hours worked\n',
      externalIds: [
        {
          id: 'wh-wor-13x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WEEKLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
      text: 'Weekly limits on overtime hours worked',
      externalIds: [
        {
          id: 'wh-wor-14x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MONTHLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
      text: 'Monthly limits on overtime hours worked',
      externalIds: [
        {
          id: 'wh-wor-15x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'YEARLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
      text: 'Yearly limits on overtime hours worked',
      externalIds: [
        {
          id: 'wh-wor-16x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wh-wor-17x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe what "Other" type of overtime hours worked is not in line with legal limits:',
        externalIds: [
          {
            id: 'wh-wor-18f',
            version: '1.5.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'DAILY_LIMITS_ON_OVERTIME_HOURS_WORKED_',
                'WEEKLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
                'MONTHLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
                'YEARLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-wor-12',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6650,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
